// biome-ignore lint/style/noRestrictedImports: encapsulation
import { isSameDay as isSameDay_, subDays } from "date-fns";

import type { RelativeTimeOptions } from "../relative-time-options";
import type { Time } from "../time";

export function isYesterday(time: Time, { now }: RelativeTimeOptions): boolean {
	return isSameDay_(time, subDays(now, 1));
}
